var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var Reservation = require('./parts/_reservation');
        window.RoomSelection = require('./parts/_rooms');
        var FlyManager = require('./parts/_fly');
        var OneClickPopup = require('./parts/_one-click');

        var OnlineBooking = function () {
            function OnlineBooking(params) {
                _classCallCheck(this, OnlineBooking);

                this.selectors = {
                    tourPrice: '#tourPrice',
                    tourPriceWithSign: '#tourPriceWithSign',
                    bonusesForTour: '#bonusesForTour',
                    onlineBookingPageWrapper: '#onlineBookingPageWrapper',
                    nextStepButton: '#nextStepBtn',
                    priceChangedBlock: '.tour-price-changed-block',
                    priceChangedLabel: '.tour-price-changed-block .change-str'
                };

                this.isActualTour = params.isActualTour ? params.isActualTour : false;
                this.isAuth = params.isAuth ? params.isAuth : false;

                this.tourId = document.querySelector('.online-booking-page').dataset.id;
                this.links = params.links ? params.links : null;

                this.fly = null;
                this.reservation = null;
                this.oneClickPopup = null;

                this.onlineBookingPageWrapper = document.querySelector(this.selectors.onlineBookingPageWrapper);
                this.nextStepButton = document.querySelector(this.selectors.nextStepButton);
                this.nextStepButtonLabel = this.nextStepButton ? this.nextStepButton.querySelector('.btn-next-step__label') : null;
                this.nextStepButtonDefaultText = this.nextStepButtonLabel ? this.nextStepButtonLabel.textContent.trim() : 'Забронировать тур';
                this.isPriceRecalculating = false;

                this.init();

                this.handlers();
            }

            _createClass(OnlineBooking, [{
                key: "init",
                value: function init() {
                    // хз зачем это было сделано
                    ///history.pushState(null, '', '/reservation/' + this.tourId);

                    if (this.isActualTour) {
                        this.initReservation();
                        this.initFly();
                        this.initOneClickPopup();
                    }

                    var eventName = this.isAuth ? 'book_online_page_open_auth_desktop' : 'book_online_page_open_desktop';
                    window.brxTracking.sendAnalyticsEvent(eventName);
                }
            }, {
                key: "initReservation",
                value: function initReservation() {
                    this.reservation = new Reservation().setTourId(this.tourId).setLinkReservation(this.links.createOnlineBooking);

                    this.reservation.init();
                }
            }, {
                key: "initFly",
                value: function initFly() {
                    var self = this;
                    self.fly = new FlyManager().setTourId(self.tourId).setRecalculateTourLink(self.links.recalculateTour).setGetFlightsLink(self.links.getFlights);

                    self.fly.init();

                    window.eventDispatcher.addEventListener('showTourExpired', function (html) {
                        self.onlineBookingPageWrapper.insertAdjacentHTML('beforebegin', html);
                        self.onlineBookingPageWrapper.classList.add('overlay');

                        var helpPopup = document.querySelector('.help-popup');
                        if (helpPopup) {
                            helpPopup.classList.add('hide');
                        }

                        document.querySelector('.online-booking-page').scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    });

                    document.addEventListener('DOMContentLoaded', function () {
                        self.fly.renderFlights();
                    });
                }
            }, {
                key: "initOneClickPopup",
                value: function initOneClickPopup() {
                    this.oneClickPopup = new OneClickPopup().setTourId(this.tourId).setLinkCallbackCreate(this.links.linkCallbackCreate);

                    this.oneClickPopup.init();
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    var self = this;

                    window.eventDispatcher.addEventListener('recalculateTour', function (data) {
                        _this.recalculateTour(data);
                    });

                    window.eventDispatcher.addEventListener('showOverlayPage', function (withLoading) {
                        _this.showOverlayPage(withLoading);
                    });

                    window.eventDispatcher.addEventListener('hideOverlayPage', function () {
                        _this.hideOverlayPage();
                    });

                    window.eventDispatcher.addEventListener('_recalc-tour-is-increased', function (data) {
                        _this.handlePriceRecalculated(data);
                    });

                    window.eventDispatcher.addEventListener('authSuccessActualPriceModalBooking', function () {
                        _this.isAuth = true;

                        if (window.authWidget && window.authWidget.authPlace === 'actual-price-modal-booking') {
                            window.authWidget.authPlace = 'booking';
                        }

                        var actualPriceModalAuthButton = document.querySelector('#actualPriceModal .js-open-auth-from-actual-price-modal');

                        if (actualPriceModalAuthButton) {
                            actualPriceModalAuthButton.classList.remove('js-open-auth-from-actual-price-modal', 'loader-btn', 'loading');
                            actualPriceModalAuthButton.classList.add('js-create-booking', 'js-create-booking-ab');

                            window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                                target: actualPriceModalAuthButton,
                                isShow: false
                            });
                        }

                        if (!document.forms.payerForm) {
                            window.location.reload();

                            return;
                        }

                        if (!_this.reservation || typeof _this.reservation.submitBookingFromActualPriceModal !== 'function') {
                            return;
                        }

                        _this.reservation.submitBookingFromActualPriceModal();
                    });

                    eventDispatcher.addEvent('click', this.selectors.nextStepButton, function (e) {
                        _this.handleNextStepClick(e);
                    });

                    eventDispatcher.addEvent('click', '.btn-next-step.js-modal-toggle', function () {
                        window.brxTracking.sendAnalyticsEvent('next_step_to_book_auth');
                        window.authWidget.sendOpenEvent();
                    });

                    eventDispatcher.addEvent('click', '.cashback-info-button', function (e) {
                        var eventProperties = {};
                        eventProperties['Place'] = 'online-booking';
                        window.brxTracking.sendAnalyticsEvent('click_cashback_from_tour', eventProperties);
                    });

                    eventDispatcher.addEvent('click', '.bonus-button-auth', function (e) {
                        var eventProperties = {};
                        eventProperties['Place'] = 'online-booking';
                        window.brxTracking.sendAnalyticsEvent('click_on_button_bonuses_for_authorization', eventProperties);
                    });

                    eventDispatcher.addAllEvent('change', '.js-change-citizenship', function (e) {
                        var target = e.currentTarget;
                        var defaultId = '1'; //казахстан
                        var citizenshipId = target.value;
                        var parentTouristForm = target.closest('form .tourist-form');
                        var parentPayerForm = target.closest('form .payer-form');

                        var parentForm = parentPayerForm ? parentPayerForm : parentTouristForm;
                        var payerIin = parentForm.querySelector('.js-payer-iin');
                        var payerPassport = parentForm.querySelector('.js-payer-passport');

                        if (citizenshipId === defaultId) {
                            if (payerPassport) {
                                payerPassport.classList.toggle('hide', payerPassport.querySelector('[data-passport-always-required]').dataset.passportAlwaysRequired !== '1');
                            }
                            if (payerIin) {
                                payerIin.classList.remove('hide');
                            }
                        } else {
                            if (payerPassport) {
                                payerPassport.classList.remove('hide');
                            }
                            if (payerIin) {
                                payerIin.classList.add('hide');
                            }
                        }
                    });

                    eventDispatcher.addAllEvent('click', '.collapse-toggle', function (e) {
                        var toggle = e.currentTarget;
                        var collapseId = toggle.dataset.collapse;
                        var parent = toggle.closest('.collapse');
                        var content = parent.querySelector('#' + collapseId);

                        if (parent.classList.contains('open')) {
                            parent.classList.remove('open');
                        } else {
                            parent.classList.add('open');
                        }

                        content.classList.add('in');
                    });
                }
            }, {
                key: "handleNextStepClick",
                value: function handleNextStepClick(event) {
                    if (this.isPriceRecalculating || !this.nextStepButton) {
                        return;
                    }

                    if (!this.isAuth && !this.shouldOpenActualPriceModal()) {
                        window.brxTracking.sendAnalyticsEvent('next_step_to_book_auth');
                        this.openAuthModal();

                        return;
                    }

                    this.startNextStepProgress();
                    this.nextStepButton.removeAttribute('data-price-checked');
                    window.eventDispatcher.dispatchEvent('actualPriceModal:resetHeader');

                    eventDispatcher.dispatchEvent('_recalc-tour', {
                        isMobile: false,
                        tourIdParentElemClass: '.main',
                        tourIdTargetElemClass: '.online-booking-page',
                        flightIdsParentElemClass: '.flights',
                        flightIdsTargetElemClass: '.flight',
                        buttonNextStep: this.selectors.nextStepButton,
                        currentCashbackSumLabel: this.selectors.bonusesForTour,
                        currentPriceLabel: '.tour-price',
                        currentPriceValue: 'input[name="tourPriceValue"]',
                        priceChangedBlock: this.selectors.priceChangedBlock,
                        priceRestLabel: '.tour-price-changed-block__price',
                        isPriceChecked: false
                    });
                }
            }, {
                key: "handlePriceRecalculated",
                value: function handlePriceRecalculated() {
                    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    if (!this.isPriceRecalculating) {
                        return;
                    }

                    if (data.status === 'error') {
                        this.stopNextStepProgress();
                        this.handleRecalculateError();

                        return;
                    }

                    window.eventDispatcher.dispatchEvent('actualPriceModal:updateHeader', data);

                    if (this.shouldOpenActualPriceModal(data)) {
                        this.stopNextStepProgress();
                        this.sendActualPriceModalOpenEvent(data);
                        window.eventDispatcher.dispatchEvent('actualPriceModal:open');

                        return;
                    }

                    this.finishNextStepProgress();
                    this.continueToBooking();
                }
            }, {
                key: "handleRecalculateError",
                value: function handleRecalculateError() {
                    if (this.isAuth) {
                        this.continueToBooking();

                        return;
                    }

                    window.brxTracking.sendAnalyticsEvent('next_step_to_book_auth');

                    if (window.authWidget) {
                        window.authWidget.authPlace = 'actual-price-modal-booking';

                        if (typeof window.authWidget.sendOpenEvent === 'function') {
                            window.authWidget.sendOpenEvent();
                        }
                    }

                    this.openAuthModal();
                }
            }, {
                key: "shouldOpenActualPriceModal",
                value: function shouldOpenActualPriceModal() {
                    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    return window.app.host === 'ht.kz';
                }
            }, {
                key: "continueToBooking",
                value: function continueToBooking() {
                    if (!this.reservation || typeof this.reservation.submitBooking !== 'function') {
                        return;
                    }

                    this.stopNextStepProgress();
                    window.eventDispatcher.dispatchEvent('_block-page');
                    this.reservation.submitBooking(false, this.nextStepButton);
                }
            }, {
                key: "sendActualPriceModalOpenEvent",
                value: function sendActualPriceModalOpenEvent() {
                    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    var eventProperties = {};
                    eventProperties['Actual Type'] = data.status || 'actual';

                    window.brxTracking.sendAnalyticsEvent('open_actual_price_modal', eventProperties);
                }
            }, {
                key: "openAuthModal",
                value: function openAuthModal() {
                    window.setTimeout(function () {
                        var authModal = document.getElementById('auth-modal');

                        if (!authModal || typeof Modal === 'undefined') {
                            return;
                        }

                        window.modals = { auth: new Modal({ el: authModal }).show() };

                        var authModalInstance = window.modals.auth;

                        if (authModalInstance && typeof authModalInstance.on === 'function') {
                            authModalInstance.on('hidden', function () {
                                if (window.authWidget && window.authWidget.authPlace === 'actual-price-modal-booking') {
                                    window.authWidget.authPlace = 'booking';
                                }
                            });
                        }

                        var phoneInput = document.querySelector('.auth-form__phone');

                        if (phoneInput) {
                            phoneInput.focus();
                        }
                    }, 0);
                }
            }, {
                key: "startNextStepProgress",
                value: function startNextStepProgress() {
                    if (!this.nextStepButton) {
                        return;
                    }

                    this.isPriceRecalculating = true;
                    this.nextStepButton.disabled = true;
                    this.nextStepButton.classList.add('loader-btn');
                }
            }, {
                key: "finishNextStepProgress",
                value: function finishNextStepProgress() {
                    if (!this.nextStepButton) {
                        return;
                    }

                    this.isPriceRecalculating = false;
                    this.nextStepButton.disabled = true;
                    this.nextStepButton.classList.remove('loader-btn');
                }
            }, {
                key: "stopNextStepProgress",
                value: function stopNextStepProgress() {
                    if (!this.nextStepButton) {
                        return;
                    }

                    this.isPriceRecalculating = false;
                    this.nextStepButton.disabled = false;
                    this.nextStepButton.classList.remove('loader-btn');
                }
            }, {
                key: "recalculateTour",
                value: function recalculateTour(recalculateTourData) {
                    var currencySign = recalculateTourData.currencySign;
                    var currencyStr = recalculateTourData.currencyStr;

                    var tourPrice = document.querySelector(this.selectors.tourPrice);
                    var tourPriceWithSign = document.querySelector(this.selectors.tourPriceWithSign);
                    var bonusesForTour = document.querySelector(this.selectors.bonusesForTour);

                    if (recalculateTourData.isActual) {
                        if (tourPrice) {
                            tourPrice.innerHTML = recalculateTourData.totalPrice + currencyStr;
                        }

                        if (tourPriceWithSign) {
                            tourPriceWithSign.innerHTML = recalculateTourData.totalPrice + currencySign;
                        }

                        if (bonusesForTour) {
                            bonusesForTour.innerHTML = recalculateTourData.bonusesForTour + currencyStr;
                        }

                        if (recalculateTourData.isTourCalculated) {
                            window.eventDispatcher.dispatchEvent('renderFlights');
                        } else {
                            window.eventDispatcher.dispatchEvent('changeMainFly');
                        }
                        this.hideOverlayPage();
                    } else {
                        window.eventDispatcher.dispatchEvent('showTourExpired', recalculateTourData.notActualTour);
                    }
                }
            }, {
                key: "showOverlayPage",
                value: function showOverlayPage() {
                    var withLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    this.onlineBookingPageWrapper.classList.add('overlay');
                    this.onlineBookingPageWrapper.insertAdjacentHTML('beforeend', '<div class="loading"></div>');
                }
            }, {
                key: "hideOverlayPage",
                value: function hideOverlayPage() {
                    this.onlineBookingPageWrapper.classList.remove('overlay');
                }
            }]);

            return OnlineBooking;
        }();

        window.OnlineBooking = OnlineBooking;
    }, { "./parts/_fly": 2, "./parts/_one-click": 3, "./parts/_reservation": 4, "./parts/_rooms": 5 }], 2: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var FlyManager = function () {
            function FlyManager() {
                _classCallCheck(this, FlyManager);

                this.selectors = {
                    changeFly: '.js-change-fly',
                    selectFly: '.js-select-fly'
                };

                this.tourId = null;
                this.linkRecalculateTour = null;
                this.linkGetFlights = null;

                this.currentSelectFlyBtn = null;
                this.isChangedFly = false;
                this.flightsContent = document.querySelector('#flightsContent');
                this.skeletonContent = this.flightsContent ? this.flightsContent.innerHTML : '';

                this.handlers();
            }

            _createClass(FlyManager, [{
                key: "init",
                value: function init() {
                    this.changeFly();
                    this.selectFly();
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this2 = this;

                    window.eventDispatcher.addEventListener('renderFlights', function () {
                        _this2.renderFlights();
                    });

                    window.eventDispatcher.addEventListener('changeMainFly', function () {
                        _this2.changeMainFly();
                    });
                }
            }, {
                key: "setTourId",
                value: function setTourId(id) {
                    this.tourId = id;

                    return this;
                }
            }, {
                key: "setRecalculateTourLink",
                value: function setRecalculateTourLink(link) {
                    this.linkRecalculateTour = link;

                    return this;
                }
            }, {
                key: "setGetFlightsLink",
                value: function setGetFlightsLink(link) {
                    this.linkGetFlights = link;

                    return this;
                }
            }, {
                key: "changeFly",
                value: function changeFly() {
                    var changeFly = document.querySelector(this.selectors.changeFly);

                    if (changeFly) {
                        changeFly.addEventListener('click', function (e) {
                            var mainFlight = document.querySelector('.main-flight');
                            var flightsList = document.querySelector('.flights-list');

                            if (flightsList.classList.contains('hide')) {
                                mainFlight.classList.add('hide');
                                flightsList.classList.remove('hide');
                            } else {
                                flightsList.classList.add('hide');
                                mainFlight.classList.remove('hide');
                            }
                        });
                    }
                }
            }, {
                key: "selectFly",
                value: function selectFly() {
                    var self = this;
                    var selectFlights = document.querySelectorAll(this.selectors.selectFly);

                    if (selectFlights) {

                        selectFlights.forEach(function (selectFly) {
                            selectFly.addEventListener('click', function (e) {
                                self.currentSelectFlyBtn = e.currentTarget;
                                self.currentSelectFlyBtn.disabled = true;
                                var flightIds = self.getFlightIds(e.currentTarget);
                                window.eventDispatcher.dispatchEvent('showOverlayPage', true);
                                self.sendRecalculateRequest(flightIds);
                            });
                        });
                    }
                }
            }, {
                key: "changeMainFly",
                value: function changeMainFly() {
                    var btn = this.currentSelectFlyBtn;
                    var fly = btn.closest('.online-booking-flight').querySelector('.flights');

                    var mainFly = document.querySelector('.main-flight .online-booking-flight .flights');

                    mainFly.innerHTML = fly.innerHTML;

                    var mainFlight = document.querySelector('.main-flight');
                    var flightsList = document.querySelector('.flights-list');

                    flightsList.classList.add('hide');
                    mainFlight.classList.remove('hide');
                }
            }, {
                key: "renderFlights",
                value: function renderFlights() {
                    var _this3 = this;

                    var self = this;
                    self.renderFlightsSkeleton();

                    ajax.post(this.linkGetFlights, { params: { tourId: self.tourId } }, function (data) {
                        if (data.success) {
                            if (data.responseData) {
                                if (data.responseData.flights) {
                                    _this3.flightsContent.innerHTML = data.responseData.flights;
                                    _this3.init();
                                } else {
                                    _this3.flightsContent.remove();
                                    console.log(data.error);
                                }
                            } else {
                                _this3.flightsContent.remove();
                                console.log(data.error);
                            }
                        } else {
                            _this3.flightsContent.remove();
                            console.log(data.error);
                        }
                    });
                }
            }, {
                key: "renderFlightsSkeleton",
                value: function renderFlightsSkeleton() {
                    this.flightsContent.innerHTML = this.skeletonContent;
                }
            }, {
                key: "getFlightIds",
                value: function getFlightIds(target) {
                    var parent = target.closest('.online-booking-flight');
                    var flights = parent.querySelectorAll('.flight');

                    var flightIds = [];

                    flights.forEach(function (item) {
                        flightIds.push(item.dataset.id);
                    });

                    return flightIds;
                }
            }, {
                key: "sendRecalculateRequest",
                value: function sendRecalculateRequest(flightIds) {
                    var self = this;
                    var params = {
                        tourId: this.tourId,
                        flightIds: flightIds
                    };

                    ajax.get(this.linkRecalculateTour, { params: params }, function (data) {
                        if (data.success && data.responseData) {
                            window.eventDispatcher.dispatchEvent('recalculateTour', data.responseData);
                            self.currentSelectFlyBtn.disabled = false;
                            self.isChangedFly = true;

                            self.flightsContent.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        } else {
                            console.log(data.error);
                        }
                    });
                }
            }]);

            return FlyManager;
        }();

        module.exports = FlyManager;
    }, {}], 3: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var OneClickPopup = function () {
            function OneClickPopup() {
                _classCallCheck(this, OneClickPopup);

                this.selectors = {
                    createCallback: '.help-popup'
                };

                this.tourId = null;
                this.linkCallbackCreate = null;
                this.callbackPhoneMask = null;
            }

            _createClass(OneClickPopup, [{
                key: "init",
                value: function init() {
                    this.initCallbackPhoneMask();
                    this.handlers();
                }
            }, {
                key: "setTourId",
                value: function setTourId(id) {
                    this.tourId = id;

                    return this;
                }
            }, {
                key: "setLinkCallbackCreate",
                value: function setLinkCallbackCreate(link) {
                    this.linkCallbackCreate = link;

                    return this;
                }
            }, {
                key: "initCallbackPhoneMask",
                value: function initCallbackPhoneMask() {
                    var element = document.getElementById('js-callback-phone-inputmask');
                    if (element) {
                        this.callbackPhoneMask = IMask(document.getElementById('js-callback-phone-inputmask'), {
                            mask: '(000) 000-00-00',
                            definitions: {
                                X: {
                                    mask: '0',
                                    displayChar: 'X',
                                    placeholderChar: '#'
                                }
                            },
                            lazy: false,
                            overwrite: 'shift'
                        });
                    }
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var self = this;
                    this.changeCountryPhoneCode();
                    this.clickBtnCreateCallback();

                    eventDispatcher.addEvent('click', '.js-close-popup', function (e) {
                        var target = e.currentTarget;
                        var parent = target.closest('.help-popup');

                        var expires = new Date();
                        expires.setDate(expires.getDate() + 1);
                        var existingCookie = document.cookie.replace(/(?:(?:^|.*;\s*)oneClickPopupTourIds\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                        var tourIds = existingCookie.split(',').filter(function (id) {
                            return id !== '';
                        });

                        if (!tourIds.includes(self.tourId)) {
                            tourIds.push(self.tourId);
                        }

                        if (target.classList.contains('is-auth')) {
                            window.brxTracking.sendAnalyticsEvent('close_one_click_popup_auth');
                        }

                        document.cookie = "oneClickPopupTourIds=" + tourIds.join(',') + "; expires=" + expires + "; path=/";

                        parent.remove();
                    });

                    eventDispatcher.addEvent('click', '.btn-booking-one-click', function (e) {
                        var eventProperties = {};
                        eventProperties['Type'] = 'callback-form';

                        window.brxTracking.sendAnalyticsEvent('open_one_click_modal', eventProperties);
                    });
                }
            }, {
                key: "changeCountryPhoneCode",
                value: function changeCountryPhoneCode() {
                    var _this4 = this;

                    eventDispatcher.addEvent('change', '#s_oneClickCountryPhoneCode', function (event) {
                        var target = event.target;

                        var select = target.closest('.pseudo-select');
                        var option = select.querySelector('.options div[data-value="' + target.value + '"]');

                        if (option) {

                            var phone = document.querySelector('.auth-form__phone');
                            if (phone) {
                                phone.value = '';
                            }

                            _this4.callbackPhoneMask.updateValue();
                            _this4.callbackPhoneMask.updateOptions({
                                mask: option.querySelector('.code').dataset.mask.replace(/9/g, '0')
                            });
                        }
                    });
                }
            }, {
                key: "clickBtnCreateCallback",
                value: function clickBtnCreateCallback() {
                    var _this5 = this;

                    var self = this;
                    eventDispatcher.addEvent('click', '.js-callback-btn', function (event) {
                        var target = event.currentTarget;

                        var callbackFormData = new FormData(document.forms.callbackForm);
                        var tourId = _this5.tourId;

                        var dataParams = {
                            callbackFormData: _this5.getFormData(callbackFormData),
                            tourId: tourId
                        };

                        window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: target,
                            isShow: true
                        });

                        self.createCallback(dataParams, target);
                    });
                }
            }, {
                key: "createCallback",
                value: function createCallback(dataParams, target) {
                    var _this6 = this;

                    var self = this;

                    ajax.post(self.linkCallbackCreate, { params: dataParams }, function (data) {
                        _this6.beforeMarkErrorsField();
                        var eventProperties = {};

                        if (data.success && data.responseData.callbackResponse) {
                            var content = target.closest('.modal-body');
                            content.querySelector('.popup-form').classList.add('hide');
                            content.querySelector('.js-callback-result').classList.remove('hide');

                            eventProperties['Crm Id'] = data.responseData.crmId;
                            window.brxTracking.sendAnalyticsEvent('callback_create_successfull', eventProperties);

                            var expires = new Date();
                            expires.setDate(expires.getDate() + 1);
                            var existingCookie = document.cookie.replace(/(?:(?:^|.*;\s*)oneClickPopupTourIds\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                            var tourIds = existingCookie.split(',').filter(function (id) {
                                return id !== '';
                            });

                            if (!tourIds.includes(self.tourId)) {
                                tourIds.push(self.tourId);
                            }

                            document.cookie = "oneClickPopupTourIds=" + tourIds.join(',') + "; expires=" + expires + "; path=/";
                            document.cookie = "dontShowOneCLickPopup=true; expires=" + expires + "; path=/";
                        } else {
                            window.brxTracking.sendAnalyticsEvent('callback_create_fail', eventProperties);

                            if (data.errors) {
                                _this6.setErrors(data.errors);
                            }
                        }

                        window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: target,
                            isShow: false
                        });
                    });
                }
            }, {
                key: "getFormData",
                value: function getFormData(formData) {
                    var data = {};

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = formData.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var key = _step.value;

                            var keys = key.replace(/\]/g, '').split('[');
                            var obj = data;

                            for (var i = 0; i < keys.length; i++) {
                                var currentKey = keys[i];
                                if (i === keys.length - 1) {
                                    obj[currentKey] = formData.get(key);
                                } else {
                                    obj[currentKey] = obj[currentKey] || {};
                                    obj = obj[currentKey];
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    return data;
                }
            }, {
                key: "setErrors",
                value: function setErrors(errors) {
                    for (var type in errors) {
                        switch (type) {
                            case 'apiErrors':
                                this.setErrorsByForm(errors[type]);
                                break;
                            default:
                                this.setDefaultErrors(errors[type]);
                                break;
                        }
                    }
                }
            }, {
                key: "setErrorsByForm",
                value: function setErrorsByForm(errors) {
                    var form = document.forms.callbackForm;
                    var formFields = form.querySelectorAll('.form-control');

                    this.markErrorsField(formFields, errors, 'CallbackForm');
                }
            }, {
                key: "setDefaultErrors",
                value: function setDefaultErrors(errors) {
                    var form = document.forms.callbackForm;
                    var formFields = form.querySelectorAll('.form-control');

                    for (var k in formFields) {
                        for (var j in errors) {
                            if (formFields[k].name === j) {
                                var formGroup = formFields[k].closest('.form-group');
                                var errorText = document.createElement('div');
                                errorText.className = 'error-text';
                                errorText.innerText = errors[j];
                                formFields[k].parentElement.after(errorText);
                                formGroup.classList.add('error');
                            }
                        }
                    }
                }
            }, {
                key: "markErrorsField",
                value: function markErrorsField(formFields, errors, formName) {
                    for (var i = 0; i < formFields.length; i++) {
                        var fieldName = formFields[i].name;
                        for (var j = 0; j < errors.length; j++) {
                            if (errors[j]['field'] === fieldName) {
                                var formGroup = formFields[i].closest('.form-group');
                                var errorText = document.createElement('div');
                                errorText.className = 'error-text';
                                errorText.innerText = errors[j]['errors'];
                                formFields[i].parentElement.after(errorText);
                                formGroup.classList.add('error');
                            }
                        }
                    }
                }
            }, {
                key: "beforeMarkErrorsField",
                value: function beforeMarkErrorsField() {
                    var formGroup = document.querySelectorAll('.popup-form .form-group');

                    formGroup.forEach(function (item) {
                        if (!item.classList.contains('error')) {
                            return;
                        }

                        item.classList.remove('error');
                        item.querySelector('.error-text').remove();
                    });
                }
            }]);

            return OneClickPopup;
        }();

        module.exports = OneClickPopup;
    }, {}], 4: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var Reservation = function () {
            function Reservation() {
                _classCallCheck(this, Reservation);

                this.selectors = {
                    createBooking: '.js-create-booking'
                };

                this.tourId = null;
                this.linkReservation = null;
                this.bookingFromModal = false;
            }

            _createClass(Reservation, [{
                key: "init",
                value: function init() {
                    var _this7 = this;

                    this.createBooking();

                    if (document.cookie.split('; ').includes('openPayerModal=true')) {

                        var btn = document.querySelector('.btn-booking-payer-form');

                        if (btn) {
                            if (btn.dataset.target === 'one-click-popup') {
                                btn.click();

                                document.cookie = "openPayerModal=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                            }
                        }
                    }

                    eventDispatcher.addEventListener('invalidPayer', function () {
                        var btn = document.querySelector('.btn-booking-payer-form');

                        if (!btn) {
                            btn = document.querySelector('.js-create-booking');
                        } else {
                            btn.click();
                        }

                        if (btn) {
                            btn.classList.remove('loader-btn');
                        }

                        window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: btn,
                            isShow: false
                        });
                    });

                    eventDispatcher.on('click', '.btn-booking-payer-form', function () {
                        _this7.openPayerFormModal();
                    });

                    eventDispatcher.on('input', '.form-group .form-control', function () {
                        _this7.beforeMarkErrorsField();
                    });

                    eventDispatcher.on('click', '.payer-validate', function (e) {
                        var btn = e.target;
                        btn.classList.add('btn-booking-payer-form');
                        btn.classList.add('js-modal-toggle');
                        btn.classList.remove('payer-validate');

                        if (btn.dataset.target === 'auth') {
                            var date = new Date();
                            date.setTime(date.getTime() + 5 * 60 * 1000);
                            document.cookie = "openPayerModal=true; expires=" + date.toUTCString() + "; path=/";

                            window.authWidget.authPlace = 'one-click-popup';

                            var eventProperties = {};
                            eventProperties['Type'] = 'payer-form';
                            window.brxTracking.sendAnalyticsEvent('open_one_click_modal', eventProperties);

                            btn.click();
                        } else {
                            document.querySelector('#nextStepBtn').click();

                            window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                                target: btn,
                                isShow: true
                            });
                        }
                    });
                }
            }, {
                key: "setTourId",
                value: function setTourId(id) {
                    this.tourId = id;

                    return this;
                }
            }, {
                key: "setLinkReservation",
                value: function setLinkReservation(link) {
                    this.linkReservation = link;

                    return this;
                }
            }, {
                key: "createBooking",
                value: function createBooking() {
                    var createBooking = document.querySelector(this.selectors.createBooking);

                    if (createBooking) {
                        var self = this;

                        eventDispatcher.on('click', this.selectors.createBooking, function (e, element) {
                            self.submitBooking(element.classList.contains('js-create-booking-ab'), element);
                        });
                    }
                }
            }, {
                key: "submitBookingFromActualPriceModal",
                value: function submitBookingFromActualPriceModal() {
                    var targetBtn = document.querySelector('#actualPriceModal .js-create-booking-ab') || document.querySelector('#actualPriceModal .js-open-auth-from-actual-price-modal') || document.querySelector('.js-create-booking-ab') || document.querySelector('.js-open-auth-from-actual-price-modal');

                    this.submitBooking(true, targetBtn);
                }
            }, {
                key: "submitBooking",
                value: function submitBooking(isFromModal, targetElement) {
                    this.bookingFromModal = isFromModal;
                    var targetBtn = this.bookingFromModal ? document.querySelector('.js-create-booking-ab') || document.querySelector('.js-open-auth-from-actual-price-modal') || targetElement : targetElement;

                    if (!targetBtn || targetBtn.disabled || targetBtn.classList.contains('loader-btn')) {
                        return;
                    }

                    window.brxTracking.sendAnalyticsEvent('booking_button_click');
                    var data = this.getBookingData();

                    targetBtn.classList.add('loader-btn');

                    window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                        target: targetBtn,
                        isShow: true
                    });
                    this.sendBookingRequest(data, targetBtn);
                }
            }, {
                key: "getBookingData",
                value: function getBookingData() {
                    var _this8 = this;

                    var payerFormData = new FormData(document.forms.payerForm);
                    var passportForms = document.querySelectorAll('.tourist-form.collapse.open form');

                    var tourId = document.querySelector('.online-booking-page').dataset.id;
                    var payerComment = document.querySelector('.js-payer-comment').value;

                    var data = {
                        payerForm: this.getFormData(payerFormData),
                        tourId: tourId,
                        payerComment: payerComment
                    };

                    if (!this.bookingFromModal) {
                        passportForms.forEach(function (form) {
                            var passportForm = new FormData(form);
                            var formData = _this8.getFormData(passportForm);

                            if (formData.TouristForm) {
                                data.TouristForm = data.TouristForm || {};

                                Object.entries(formData.TouristForm).forEach(function (_ref) {
                                    var _ref2 = _slicedToArray(_ref, 2),
                                        key = _ref2[0],
                                        value = _ref2[1];

                                    data.TouristForm[key] = value;
                                });
                            }
                        });
                    }

                    return data;
                }
            }, {
                key: "sendBookingRequest",
                value: function sendBookingRequest(dataParams, targetBtn) {
                    var _this9 = this;

                    var self = this;
                    window.brxTracking.sendAnalyticsEvent('book_online_book_tour');
                    ajax.post(self.linkReservation, { params: dataParams }, function (data) {
                        _this9.beforeMarkErrorsField();

                        var shouldUnlockButton = false;

                        if (data.success && data.responseData) {
                            window.brxTracking.sendAnalyticsEvent('book_online_book_tour_success');
                            window.brxTracking.setYaEvent('BookOnlineAfterAuth.NextStep');
                            if (data.responseData.redirectUrl) {
                                window.location.href = data.responseData.redirectUrl;
                            }
                        } else {
                            shouldUnlockButton = true;
                            _this9.unblockPage();
                            window.brxTracking.sendAnalyticsEvent('book_online_book_tour_error');
                            if (_this9.bookingFromModal) {
                                _this9.closeOpenedModal();
                            }

                            if (data.errors) {
                                _this9.setErrors(data.errors);
                            } else if (data.responseData && data.responseData.redirectUrl) {
                                alert('Истекла авторизация. Страница будет перезагружена.');
                                window.location.href = data.responseData.redirectUrl;
                            }

                            if (!_this9.bookingFromModal) {
                                window.eventDispatcher.dispatchEvent('invalidPayer');
                            }
                        }

                        if (shouldUnlockButton) {
                            targetBtn.classList.remove('loader-btn');
                            window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                                target: targetBtn,
                                isShow: false
                            });
                        }
                    });
                }
            }, {
                key: "unblockPage",
                value: function unblockPage() {
                    window.eventDispatcher.dispatchEvent('_block-page', {
                        enable: false
                    });
                }
            }, {
                key: "closeOpenedModal",
                value: function closeOpenedModal() {
                    if (window.modal && typeof window.modal.close === 'function') {
                        window.modal.close('.modal2');
                    }
                }
            }, {
                key: "getFormData",
                value: function getFormData(formData) {
                    var data = {};

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = formData.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var key = _step2.value;

                            var keys = key.replace(/\]/g, '').split('[');
                            var obj = data;

                            for (var i = 0; i < keys.length; i++) {
                                var currentKey = keys[i];
                                if (i === keys.length - 1) {
                                    obj[currentKey] = formData.get(key);
                                } else {
                                    obj[currentKey] = obj[currentKey] || {};
                                    obj = obj[currentKey];
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    return data;
                }
            }, {
                key: "setErrors",
                value: function setErrors(errors) {
                    for (var type in errors) {
                        switch (type) {
                            case 'payer':
                                this.setPayerErrors(errors[type]);
                                break;
                            case 'TouristForm':
                                this.setTouristErrors(errors[type]);
                                break;
                            case 'bookingCreateError':
                                window.location.href = '/new/cabinet/my-tours';
                                break;
                            default:
                                this.setDefaultErrors(errors);
                                break;
                        }
                    }
                }
            }, {
                key: "setPayerErrors",
                value: function setPayerErrors(errors) {
                    var form = document.forms.payerForm;
                    var formFields = form.querySelectorAll('.form-group .form-control');

                    if (!this.bookingFromModal) {
                        document.querySelector('.tourists-info .payer').scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }

                    this.markErrorsField(formFields, errors, 'PayerForm');
                }
            }, {
                key: "setTouristErrors",
                value: function setTouristErrors(touristsErrors) {
                    var _this10 = this;

                    var forms = document.querySelectorAll('.tourist-form.collapse.open form');
                    var firstErrorForm = null;

                    var _loop = function _loop(touristKey) {
                        var form = Array.from(forms).find(function (f) {
                            return f.dataset.index === touristKey;
                        });

                        if (!form) return "continue"; // Пропускаем, если подходящая форма не найдена

                        if (!firstErrorForm) {
                            firstErrorForm = form; // Запоминаем первую форму с ошибкой
                        }

                        var formFields = form.querySelectorAll('.form-group .form-control');
                        _this10.markErrorsField(formFields, touristsErrors[touristKey], "TouristForm[" + touristKey + "]");
                    };

                    for (var touristKey in touristsErrors) {
                        var _ret = _loop(touristKey);

                        if (_ret === "continue") continue;
                    }

                    if (firstErrorForm) {
                        firstErrorForm.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }
            }, {
                key: "markErrorsField",
                value: function markErrorsField(formFields, errors, formName) {
                    for (var errorKey in errors) {
                        for (var i = 0; i < formFields.length; i++) {
                            if (formFields[i].name === formName + '[' + errorKey + ']') {
                                var formGroup = formFields[i].closest('.form-group');
                                var errorText = document.createElement('div');
                                errorText.className = 'error-text';
                                errorText.innerText = errors[errorKey];
                                formFields[i].after(errorText);
                                formGroup.classList.add('error');
                            }
                        }
                    }
                }
            }, {
                key: "beforeMarkErrorsField",
                value: function beforeMarkErrorsField() {
                    var formGroup = document.querySelectorAll('form .form-group');
                    var defaultErrors = document.querySelector('.default-errors');

                    defaultErrors.innerHTML = '';

                    formGroup.forEach(function (item) {
                        if (!item.classList.contains('error')) {
                            return;
                        }

                        item.classList.remove('error');
                        item.querySelector('.error-text').remove();
                    });
                }
            }, {
                key: "setDefaultErrors",
                value: function setDefaultErrors(errors) {
                    var defaultErrors = document.querySelector('.default-errors');

                    for (var k in errors) {
                        for (var j in errors[k]) {
                            var errorList = errors[k][j]['errors'];
                            for (var e in errorList) {
                                var errorText = document.createElement('div');
                                errorText.className = 'error-text';
                                errorText.innerText = errorList[e];

                                defaultErrors.append(errorText);
                            }
                        }
                    }
                }
            }, {
                key: "openPayerFormModal",
                value: function openPayerFormModal() {
                    var form = document.querySelector('.tourists-info .payer form[name="payerForm"]');
                    if (!form) return;

                    var modalContent = document.querySelector('.payer-form-modal');
                    if (!modalContent) {
                        return;
                    }

                    var originalParent = form.parentElement; // Запоминаем родителя
                    var originalNextSibling = form.nextSibling; // Запоминаем позицию

                    modalContent.innerHTML = ''; // Очищаем модалку
                    modalContent.appendChild(form); // Переносим форму в модалку

                    // Создаём кнопку "Оставить заявку"
                    var submitButton = document.createElement('button');
                    submitButton.type = 'button';
                    submitButton.className = 'btn btn-blue btn-next-step js-create-booking js-create-booking-ab';
                    submitButton.textContent = 'Оставить заявку';

                    // Вставляем кнопку в модалку после формы
                    modalContent.appendChild(submitButton);

                    // При закрытии модалки возвращаем форму обратно
                    window.modals['one-click-popup'].on('hidden', function (modal, event) {
                        form.name = 'payerForm';
                        if (originalNextSibling) {
                            originalParent.insertBefore(form, originalNextSibling);
                        } else {
                            originalParent.appendChild(form);
                        }
                    });

                    var eventProperties = {};
                    eventProperties['Type'] = 'payer-form';
                    window.brxTracking.sendAnalyticsEvent('open_one_click_modal', eventProperties);
                }
            }]);

            return Reservation;
        }();

        module.exports = Reservation;
    }, {}], 5: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var RoomSelection = function () {
            function RoomSelection(params) {
                var _this11 = this;

                _classCallCheck(this, RoomSelection);

                this.params = params;
                this.labels = params.labels;
                this.rooms = null;
                this.loading = false;
                this.panel = document.getElementById('bookingRoomsPanel');
                this.content = this.panel.querySelector('[data-booking-room-content]');
                this.navigation = this.panel.querySelector('[data-booking-room-nav]');
                this.button = document.querySelector('.js-change-room');
                this.selectedButton = document.querySelector('.btn-selected-room');
                this.button.addEventListener('click', function () {
                    if (_this11.loading) {
                        return;
                    }
                    if (_this11.rooms === null) {
                        _this11.load();
                    } else if (_this11.rooms.length) {
                        _this11.open();
                    }
                });
                this.load();
            }

            _createClass(RoomSelection, [{
                key: "open",
                value: function open() {
                    var _this12 = this;

                    window.modal.open({
                        header: null,
                        content: { htmlDetachSelectorId: 'bookingRoomsPanel' },
                        parentCssClass: 'hotel-reviews-panel-modal booking-room-selection-modal',
                        footer: null,
                        type: 'full',
                        onAfterShow: function onAfterShow() {
                            return _this12.initGalleries();
                        }
                    });
                    window.brxTracking.sendAnalyticsEvent('click_on_hotel_room', { Place: this.params.eventPlace });
                    if (this.rooms === null && !this.loading) {
                        this.load();
                    }
                }
            }, {
                key: "load",
                value: function load() {
                    var _this13 = this;

                    this.loading = true;
                    this.button.disabled = true;
                    this.button.title = '';
                    this.button.textContent = this.labels.loading;
                    this.button.classList.add('is-loading');
                    this.button.classList.remove('hide');
                    this.selectedButton.classList.add('hide');
                    this.content.replaceChildren();
                    this.content.textContent = this.labels.loading;
                    ajax.get(this.params.loadRoomsUrl, {}, function (data) {
                        _this13.loading = false;
                        _this13.rooms = data.success ? data.responseData.rooms : [];
                        _this13.button.disabled = false;
                        _this13.button.classList.remove('is-loading');
                        _this13.button.textContent = _this13.params.isSplitRooms ? _this13.labels.view : _this13.labels.change;
                        _this13.button.classList.toggle('hide', _this13.rooms.length === 0);
                        _this13.selectedButton.classList.toggle('hide', _this13.rooms.length !== 0);
                        _this13.render();
                    }, function () {
                        _this13.loading = false;
                        _this13.button.disabled = false;
                        _this13.button.classList.remove('is-loading');
                        _this13.button.textContent = _this13.labels.retry;
                        _this13.button.title = _this13.labels.error;
                    });
                }
            }, {
                key: "render",
                value: function render() {
                    var _this14 = this;

                    this.content.textContent = '';
                    this.content.replaceChildren();
                    this.navigation.replaceChildren();
                    var variants = this.params.isSplitRooms ? this.rooms : [this.params.baseRoom].concat(_toConsumableArray(this.rooms));
                    var activeIndex = 0;
                    variants.forEach(function (room, index) {
                        var selected = !_this14.params.isSplitRooms && index === 0;
                        var button = _this14.element('button', 'hotel-rooms-panel__tab');
                        button.type = 'button';
                        var photo = _this14.element('img', '');
                        photo.src = room.detail && room.detail.photos.length ? room.detail.photos[0] : '/x-assets/img/no-image.svg';
                        photo.alt = '';
                        photo.loading = 'lazy';
                        button.appendChild(photo);
                        var label = _this14.element('span', '', room.name);
                        if (selected || room.diff) label.appendChild(_this14.element('div', 'booking-rooms-panel__price', selected ? _this14.labels.selected : room.diff));
                        button.appendChild(label);
                        var show = function show() {
                            _this14.content.querySelectorAll('.room-selection__gallery').forEach(function (gallery) {
                                if (gallery.swiper) gallery.swiper.destroy(true, true);
                            });
                            _this14.content.replaceChildren(_this14.renderRoom(room, selected));
                            Array.from(_this14.navigation.children).forEach(function (tab) {
                                return tab.setAttribute('aria-current', String(tab === button));
                            });
                            _this14.initGalleries();
                            var scroller = _this14.panel.closest('.modal2-content');
                            if (scroller) scroller.scrollTop = 0;
                        };
                        button.addEventListener('click', function () {
                            if (activeIndex === index) return;
                            activeIndex = index;
                            if (window.brxTracking) window.brxTracking.sendAnalyticsEvent('hotel_room_change', Object.assign({}, window.app && window.app.pageParams, { context: 'booking',
                                Place: _this14.params.eventPlace, room_id: room.detail && room.detail.id, tour_id: room.tourId, room_index: index }));
                            show();
                        });
                        _this14.navigation.appendChild(button);
                        if (index === 0) show();
                    });
                    if (this.rooms.length === 0) {
                        this.content.appendChild(this.element('p', 'room-selection__message', this.labels.empty));
                    }
                }
            }, {
                key: "renderRoom",
                value: function renderRoom(room, selected) {
                    var _this15 = this;

                    var detail = room.detail;
                    var card = this.element('div', 'online-booking-rooms room-selection__room' + (!detail ? ' short-room' : ''));
                    var body = this.element('div', 'rooms content-block');
                    if (detail) {
                        body.appendChild(this.renderGallery(detail.photos, room.name));
                    }
                    var info = this.element('div', 'room-info');
                    info.appendChild(this.element('div', 'room-name', selected && detail ? detail.name : room.name));
                    info.appendChild(this.element('div', 'room-description', detail ? detail.description : ''));
                    if (detail && detail.services && detail.services.length) {
                        var _services = this.element('div', 'room-params');
                        detail.services.forEach(function (service) {
                            var item = _this15.element('div', 'room-param');
                            item.appendChild(_this15.element('span', '', service.name));
                            item.appendChild(document.createTextNode(': ' + service.value));
                            _services.appendChild(item);
                        });
                        info.appendChild(_services);
                    }
                    if (this.params.isSplitRooms && detail && detail.accommodation) {
                        var accommodation = detail.accommodation;
                        info.appendChild(this.element('p', 'room-selection__accommodation', this.labels.adults + ': ' + accommodation.adults + ', ' + this.labels.children + ': ' + accommodation.child));
                    }
                    body.appendChild(info);
                    card.appendChild(body);
                    var services = info.querySelector('.room-params');
                    if (services) card.appendChild(services);
                    var action = this.element('div', 'rooms-action content-block');
                    if (selected) {
                        action.appendChild(this.element('div', 'btn btn-selected btn-selected-room', this.labels.selected));
                    } else if (!this.params.isSplitRooms) {
                        if (room.diff) {
                            action.appendChild(this.element('div', 'room-selection__diff', room.diff));
                        }
                        var link = this.element('a', 'btn btn-blue', this.labels.select);
                        link.href = this.params.newTourUrl + '/' + encodeURIComponent(room.tourId) + window.location.search;
                        link.addEventListener('click', function () {
                            window.brxTracking.sendAnalyticsEvent('click_to_select_hotel_room', { Place: _this15.params.eventPlace });
                        });
                        action.appendChild(link);
                    }
                    var header = this.element('div', 'booking-rooms-panel__room-header');
                    header.appendChild(info.querySelector('.room-name'));
                    header.appendChild(action);
                    card.prepend(header);
                    if (!detail && !this.params.isSplitRooms) body.remove();
                    return card;
                }
            }, {
                key: "renderGallery",
                value: function renderGallery(photos, name) {
                    var _this16 = this;

                    var gallery = this.element('div', 'rooms-gallery');
                    if (!photos.length) {
                        var wrapper = this.element('div', 'room-image-wrapper');
                        var image = this.element('img', 'room-image');
                        image.src = '/x-assets/img/no-image.svg';
                        image.alt = name;
                        wrapper.appendChild(image);
                        gallery.appendChild(wrapper);
                        return gallery;
                    }
                    var slider = this.element('div', 'swiper room-selection__gallery');
                    var slides = this.element('div', 'swiper-wrapper');
                    photos.forEach(function (src) {
                        var slide = _this16.element('div', 'swiper-slide');
                        var image = _this16.element('img', '');
                        image.src = src;
                        image.alt = name;
                        image.loading = 'lazy';
                        slide.appendChild(image);
                        slides.appendChild(slide);
                    });
                    slider.appendChild(slides);
                    slider.appendChild(this.element('div', 'swiper-pagination'));
                    slider.appendChild(this.element('div', 'swiper-button-prev'));
                    slider.appendChild(this.element('div', 'swiper-button-next'));
                    gallery.appendChild(slider);
                    return gallery;
                }
            }, {
                key: "initGalleries",
                value: function initGalleries() {
                    this.content.querySelectorAll('.room-selection__gallery').forEach(function (element) {
                        if (element.swiper) {
                            element.swiper.update();
                            return;
                        }
                        new Swiper(element, {
                            slidesPerView: 1,
                            loop: false,
                            pagination: { el: element.querySelector('.swiper-pagination'), clickable: true },
                            navigation: {
                                prevEl: element.querySelector('.swiper-button-prev'),
                                nextEl: element.querySelector('.swiper-button-next')
                            }
                        });
                    });
                }
            }, {
                key: "element",
                value: function element(tag, className) {
                    var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

                    var element = document.createElement(tag);
                    element.className = className;
                    element.textContent = text;
                    return element;
                }
            }]);

            return RoomSelection;
        }();

        module.exports = RoomSelection;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var FlyManager = function () {
            function FlyManager() {
                _classCallCheck(this, FlyManager);

                this.selectors = {
                    changeFly: '.js-change-fly',
                    selectFly: '.js-select-fly'
                };

                this.tourId = null;
                this.linkRecalculateTour = null;
                this.linkGetFlights = null;

                this.currentSelectFlyBtn = null;
                this.isChangedFly = false;
                this.flightsContent = document.querySelector('#flightsContent');
                this.skeletonContent = this.flightsContent ? this.flightsContent.innerHTML : '';

                this.handlers();
            }

            _createClass(FlyManager, [{
                key: "init",
                value: function init() {
                    this.changeFly();
                    this.selectFly();
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this17 = this;

                    window.eventDispatcher.addEventListener('renderFlights', function () {
                        _this17.renderFlights();
                    });

                    window.eventDispatcher.addEventListener('changeMainFly', function () {
                        _this17.changeMainFly();
                    });
                }
            }, {
                key: "setTourId",
                value: function setTourId(id) {
                    this.tourId = id;

                    return this;
                }
            }, {
                key: "setRecalculateTourLink",
                value: function setRecalculateTourLink(link) {
                    this.linkRecalculateTour = link;

                    return this;
                }
            }, {
                key: "setGetFlightsLink",
                value: function setGetFlightsLink(link) {
                    this.linkGetFlights = link;

                    return this;
                }
            }, {
                key: "changeFly",
                value: function changeFly() {
                    var changeFly = document.querySelector(this.selectors.changeFly);

                    if (changeFly) {
                        changeFly.addEventListener('click', function (e) {
                            var mainFlight = document.querySelector('.main-flight');
                            var flightsList = document.querySelector('.flights-list');

                            if (flightsList.classList.contains('hide')) {
                                mainFlight.classList.add('hide');
                                flightsList.classList.remove('hide');
                            } else {
                                flightsList.classList.add('hide');
                                mainFlight.classList.remove('hide');
                            }
                        });
                    }
                }
            }, {
                key: "selectFly",
                value: function selectFly() {
                    var self = this;
                    var selectFlights = document.querySelectorAll(this.selectors.selectFly);

                    if (selectFlights) {

                        selectFlights.forEach(function (selectFly) {
                            selectFly.addEventListener('click', function (e) {
                                self.currentSelectFlyBtn = e.currentTarget;
                                self.currentSelectFlyBtn.disabled = true;
                                var flightIds = self.getFlightIds(e.currentTarget);
                                window.eventDispatcher.dispatchEvent('showOverlayPage', true);
                                self.sendRecalculateRequest(flightIds);
                            });
                        });
                    }
                }
            }, {
                key: "changeMainFly",
                value: function changeMainFly() {
                    var btn = this.currentSelectFlyBtn;
                    var fly = btn.closest('.online-booking-flight').querySelector('.flights');

                    var mainFly = document.querySelector('.main-flight .online-booking-flight .flights');

                    mainFly.innerHTML = fly.innerHTML;

                    var mainFlight = document.querySelector('.main-flight');
                    var flightsList = document.querySelector('.flights-list');

                    flightsList.classList.add('hide');
                    mainFlight.classList.remove('hide');
                }
            }, {
                key: "renderFlights",
                value: function renderFlights() {
                    var _this18 = this;

                    var self = this;
                    self.renderFlightsSkeleton();

                    ajax.post(this.linkGetFlights, { params: { tourId: self.tourId } }, function (data) {
                        if (data.success) {
                            if (data.responseData) {
                                if (data.responseData.flights) {
                                    _this18.flightsContent.innerHTML = data.responseData.flights;
                                    _this18.init();
                                } else {
                                    _this18.flightsContent.remove();
                                    console.log(data.error);
                                }
                            } else {
                                _this18.flightsContent.remove();
                                console.log(data.error);
                            }
                        } else {
                            _this18.flightsContent.remove();
                            console.log(data.error);
                        }
                    });
                }
            }, {
                key: "renderFlightsSkeleton",
                value: function renderFlightsSkeleton() {
                    this.flightsContent.innerHTML = this.skeletonContent;
                }
            }, {
                key: "getFlightIds",
                value: function getFlightIds(target) {
                    var parent = target.closest('.online-booking-flight');
                    var flights = parent.querySelectorAll('.flight');

                    var flightIds = [];

                    flights.forEach(function (item) {
                        flightIds.push(item.dataset.id);
                    });

                    return flightIds;
                }
            }, {
                key: "sendRecalculateRequest",
                value: function sendRecalculateRequest(flightIds) {
                    var self = this;
                    var params = {
                        tourId: this.tourId,
                        flightIds: flightIds
                    };

                    ajax.get(this.linkRecalculateTour, { params: params }, function (data) {
                        if (data.success && data.responseData) {
                            window.eventDispatcher.dispatchEvent('recalculateTour', data.responseData);
                            self.currentSelectFlyBtn.disabled = false;
                            self.isChangedFly = true;

                            self.flightsContent.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        } else {
                            console.log(data.error);
                        }
                    });
                }
            }]);

            return FlyManager;
        }();

        module.exports = FlyManager;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var OneClickPopup = function () {
            function OneClickPopup() {
                _classCallCheck(this, OneClickPopup);

                this.selectors = {
                    createCallback: '.help-popup'
                };

                this.tourId = null;
                this.linkCallbackCreate = null;
                this.callbackPhoneMask = null;
            }

            _createClass(OneClickPopup, [{
                key: "init",
                value: function init() {
                    this.initCallbackPhoneMask();
                    this.handlers();
                }
            }, {
                key: "setTourId",
                value: function setTourId(id) {
                    this.tourId = id;

                    return this;
                }
            }, {
                key: "setLinkCallbackCreate",
                value: function setLinkCallbackCreate(link) {
                    this.linkCallbackCreate = link;

                    return this;
                }
            }, {
                key: "initCallbackPhoneMask",
                value: function initCallbackPhoneMask() {
                    var element = document.getElementById('js-callback-phone-inputmask');
                    if (element) {
                        this.callbackPhoneMask = IMask(document.getElementById('js-callback-phone-inputmask'), {
                            mask: '(000) 000-00-00',
                            definitions: {
                                X: {
                                    mask: '0',
                                    displayChar: 'X',
                                    placeholderChar: '#'
                                }
                            },
                            lazy: false,
                            overwrite: 'shift'
                        });
                    }
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var self = this;
                    this.changeCountryPhoneCode();
                    this.clickBtnCreateCallback();

                    eventDispatcher.addEvent('click', '.js-close-popup', function (e) {
                        var target = e.currentTarget;
                        var parent = target.closest('.help-popup');

                        var expires = new Date();
                        expires.setDate(expires.getDate() + 1);
                        var existingCookie = document.cookie.replace(/(?:(?:^|.*;\s*)oneClickPopupTourIds\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                        var tourIds = existingCookie.split(',').filter(function (id) {
                            return id !== '';
                        });

                        if (!tourIds.includes(self.tourId)) {
                            tourIds.push(self.tourId);
                        }

                        if (target.classList.contains('is-auth')) {
                            window.brxTracking.sendAnalyticsEvent('close_one_click_popup_auth');
                        }

                        document.cookie = "oneClickPopupTourIds=" + tourIds.join(',') + "; expires=" + expires + "; path=/";

                        parent.remove();
                    });

                    eventDispatcher.addEvent('click', '.btn-booking-one-click', function (e) {
                        var eventProperties = {};
                        eventProperties['Type'] = 'callback-form';

                        window.brxTracking.sendAnalyticsEvent('open_one_click_modal', eventProperties);
                    });
                }
            }, {
                key: "changeCountryPhoneCode",
                value: function changeCountryPhoneCode() {
                    var _this19 = this;

                    eventDispatcher.addEvent('change', '#s_oneClickCountryPhoneCode', function (event) {
                        var target = event.target;

                        var select = target.closest('.pseudo-select');
                        var option = select.querySelector('.options div[data-value="' + target.value + '"]');

                        if (option) {

                            var phone = document.querySelector('.auth-form__phone');
                            if (phone) {
                                phone.value = '';
                            }

                            _this19.callbackPhoneMask.updateValue();
                            _this19.callbackPhoneMask.updateOptions({
                                mask: option.querySelector('.code').dataset.mask.replace(/9/g, '0')
                            });
                        }
                    });
                }
            }, {
                key: "clickBtnCreateCallback",
                value: function clickBtnCreateCallback() {
                    var _this20 = this;

                    var self = this;
                    eventDispatcher.addEvent('click', '.js-callback-btn', function (event) {
                        var target = event.currentTarget;

                        var callbackFormData = new FormData(document.forms.callbackForm);
                        var tourId = _this20.tourId;

                        var dataParams = {
                            callbackFormData: _this20.getFormData(callbackFormData),
                            tourId: tourId
                        };

                        window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: target,
                            isShow: true
                        });

                        self.createCallback(dataParams, target);
                    });
                }
            }, {
                key: "createCallback",
                value: function createCallback(dataParams, target) {
                    var _this21 = this;

                    var self = this;

                    ajax.post(self.linkCallbackCreate, { params: dataParams }, function (data) {
                        _this21.beforeMarkErrorsField();
                        var eventProperties = {};

                        if (data.success && data.responseData.callbackResponse) {
                            var content = target.closest('.modal-body');
                            content.querySelector('.popup-form').classList.add('hide');
                            content.querySelector('.js-callback-result').classList.remove('hide');

                            eventProperties['Crm Id'] = data.responseData.crmId;
                            window.brxTracking.sendAnalyticsEvent('callback_create_successfull', eventProperties);

                            var expires = new Date();
                            expires.setDate(expires.getDate() + 1);
                            var existingCookie = document.cookie.replace(/(?:(?:^|.*;\s*)oneClickPopupTourIds\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                            var tourIds = existingCookie.split(',').filter(function (id) {
                                return id !== '';
                            });

                            if (!tourIds.includes(self.tourId)) {
                                tourIds.push(self.tourId);
                            }

                            document.cookie = "oneClickPopupTourIds=" + tourIds.join(',') + "; expires=" + expires + "; path=/";
                            document.cookie = "dontShowOneCLickPopup=true; expires=" + expires + "; path=/";
                        } else {
                            window.brxTracking.sendAnalyticsEvent('callback_create_fail', eventProperties);

                            if (data.errors) {
                                _this21.setErrors(data.errors);
                            }
                        }

                        window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: target,
                            isShow: false
                        });
                    });
                }
            }, {
                key: "getFormData",
                value: function getFormData(formData) {
                    var data = {};

                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = formData.keys()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var key = _step3.value;

                            var keys = key.replace(/\]/g, '').split('[');
                            var obj = data;

                            for (var i = 0; i < keys.length; i++) {
                                var currentKey = keys[i];
                                if (i === keys.length - 1) {
                                    obj[currentKey] = formData.get(key);
                                } else {
                                    obj[currentKey] = obj[currentKey] || {};
                                    obj = obj[currentKey];
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    return data;
                }
            }, {
                key: "setErrors",
                value: function setErrors(errors) {
                    for (var type in errors) {
                        switch (type) {
                            case 'apiErrors':
                                this.setErrorsByForm(errors[type]);
                                break;
                            default:
                                this.setDefaultErrors(errors[type]);
                                break;
                        }
                    }
                }
            }, {
                key: "setErrorsByForm",
                value: function setErrorsByForm(errors) {
                    var form = document.forms.callbackForm;
                    var formFields = form.querySelectorAll('.form-control');

                    this.markErrorsField(formFields, errors, 'CallbackForm');
                }
            }, {
                key: "setDefaultErrors",
                value: function setDefaultErrors(errors) {
                    var form = document.forms.callbackForm;
                    var formFields = form.querySelectorAll('.form-control');

                    for (var k in formFields) {
                        for (var j in errors) {
                            if (formFields[k].name === j) {
                                var formGroup = formFields[k].closest('.form-group');
                                var errorText = document.createElement('div');
                                errorText.className = 'error-text';
                                errorText.innerText = errors[j];
                                formFields[k].parentElement.after(errorText);
                                formGroup.classList.add('error');
                            }
                        }
                    }
                }
            }, {
                key: "markErrorsField",
                value: function markErrorsField(formFields, errors, formName) {
                    for (var i = 0; i < formFields.length; i++) {
                        var fieldName = formFields[i].name;
                        for (var j = 0; j < errors.length; j++) {
                            if (errors[j]['field'] === fieldName) {
                                var formGroup = formFields[i].closest('.form-group');
                                var errorText = document.createElement('div');
                                errorText.className = 'error-text';
                                errorText.innerText = errors[j]['errors'];
                                formFields[i].parentElement.after(errorText);
                                formGroup.classList.add('error');
                            }
                        }
                    }
                }
            }, {
                key: "beforeMarkErrorsField",
                value: function beforeMarkErrorsField() {
                    var formGroup = document.querySelectorAll('.popup-form .form-group');

                    formGroup.forEach(function (item) {
                        if (!item.classList.contains('error')) {
                            return;
                        }

                        item.classList.remove('error');
                        item.querySelector('.error-text').remove();
                    });
                }
            }]);

            return OneClickPopup;
        }();

        module.exports = OneClickPopup;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var Reservation = function () {
            function Reservation() {
                _classCallCheck(this, Reservation);

                this.selectors = {
                    createBooking: '.js-create-booking'
                };

                this.tourId = null;
                this.linkReservation = null;
                this.bookingFromModal = false;
            }

            _createClass(Reservation, [{
                key: "init",
                value: function init() {
                    var _this22 = this;

                    this.createBooking();

                    if (document.cookie.split('; ').includes('openPayerModal=true')) {

                        var btn = document.querySelector('.btn-booking-payer-form');

                        if (btn) {
                            if (btn.dataset.target === 'one-click-popup') {
                                btn.click();

                                document.cookie = "openPayerModal=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                            }
                        }
                    }

                    eventDispatcher.addEventListener('invalidPayer', function () {
                        var btn = document.querySelector('.btn-booking-payer-form');

                        if (!btn) {
                            btn = document.querySelector('.js-create-booking');
                        } else {
                            btn.click();
                        }

                        if (btn) {
                            btn.classList.remove('loader-btn');
                        }

                        window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: btn,
                            isShow: false
                        });
                    });

                    eventDispatcher.on('click', '.btn-booking-payer-form', function () {
                        _this22.openPayerFormModal();
                    });

                    eventDispatcher.on('input', '.form-group .form-control', function () {
                        _this22.beforeMarkErrorsField();
                    });

                    eventDispatcher.on('click', '.payer-validate', function (e) {
                        var btn = e.target;
                        btn.classList.add('btn-booking-payer-form');
                        btn.classList.add('js-modal-toggle');
                        btn.classList.remove('payer-validate');

                        if (btn.dataset.target === 'auth') {
                            var date = new Date();
                            date.setTime(date.getTime() + 5 * 60 * 1000);
                            document.cookie = "openPayerModal=true; expires=" + date.toUTCString() + "; path=/";

                            window.authWidget.authPlace = 'one-click-popup';

                            var eventProperties = {};
                            eventProperties['Type'] = 'payer-form';
                            window.brxTracking.sendAnalyticsEvent('open_one_click_modal', eventProperties);

                            btn.click();
                        } else {
                            document.querySelector('#nextStepBtn').click();

                            window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                                target: btn,
                                isShow: true
                            });
                        }
                    });
                }
            }, {
                key: "setTourId",
                value: function setTourId(id) {
                    this.tourId = id;

                    return this;
                }
            }, {
                key: "setLinkReservation",
                value: function setLinkReservation(link) {
                    this.linkReservation = link;

                    return this;
                }
            }, {
                key: "createBooking",
                value: function createBooking() {
                    var createBooking = document.querySelector(this.selectors.createBooking);

                    if (createBooking) {
                        var self = this;

                        eventDispatcher.on('click', this.selectors.createBooking, function (e, element) {
                            self.submitBooking(element.classList.contains('js-create-booking-ab'), element);
                        });
                    }
                }
            }, {
                key: "submitBookingFromActualPriceModal",
                value: function submitBookingFromActualPriceModal() {
                    var targetBtn = document.querySelector('#actualPriceModal .js-create-booking-ab') || document.querySelector('#actualPriceModal .js-open-auth-from-actual-price-modal') || document.querySelector('.js-create-booking-ab') || document.querySelector('.js-open-auth-from-actual-price-modal');

                    this.submitBooking(true, targetBtn);
                }
            }, {
                key: "submitBooking",
                value: function submitBooking(isFromModal, targetElement) {
                    this.bookingFromModal = isFromModal;
                    var targetBtn = this.bookingFromModal ? document.querySelector('.js-create-booking-ab') || document.querySelector('.js-open-auth-from-actual-price-modal') || targetElement : targetElement;

                    if (!targetBtn || targetBtn.disabled || targetBtn.classList.contains('loader-btn')) {
                        return;
                    }

                    window.brxTracking.sendAnalyticsEvent('booking_button_click');
                    var data = this.getBookingData();

                    targetBtn.classList.add('loader-btn');

                    window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                        target: targetBtn,
                        isShow: true
                    });
                    this.sendBookingRequest(data, targetBtn);
                }
            }, {
                key: "getBookingData",
                value: function getBookingData() {
                    var _this23 = this;

                    var payerFormData = new FormData(document.forms.payerForm);
                    var passportForms = document.querySelectorAll('.tourist-form.collapse.open form');

                    var tourId = document.querySelector('.online-booking-page').dataset.id;
                    var payerComment = document.querySelector('.js-payer-comment').value;

                    var data = {
                        payerForm: this.getFormData(payerFormData),
                        tourId: tourId,
                        payerComment: payerComment
                    };

                    if (!this.bookingFromModal) {
                        passportForms.forEach(function (form) {
                            var passportForm = new FormData(form);
                            var formData = _this23.getFormData(passportForm);

                            if (formData.TouristForm) {
                                data.TouristForm = data.TouristForm || {};

                                Object.entries(formData.TouristForm).forEach(function (_ref3) {
                                    var _ref4 = _slicedToArray(_ref3, 2),
                                        key = _ref4[0],
                                        value = _ref4[1];

                                    data.TouristForm[key] = value;
                                });
                            }
                        });
                    }

                    return data;
                }
            }, {
                key: "sendBookingRequest",
                value: function sendBookingRequest(dataParams, targetBtn) {
                    var _this24 = this;

                    var self = this;
                    window.brxTracking.sendAnalyticsEvent('book_online_book_tour');
                    ajax.post(self.linkReservation, { params: dataParams }, function (data) {
                        _this24.beforeMarkErrorsField();

                        var shouldUnlockButton = false;

                        if (data.success && data.responseData) {
                            window.brxTracking.sendAnalyticsEvent('book_online_book_tour_success');
                            window.brxTracking.setYaEvent('BookOnlineAfterAuth.NextStep');
                            if (data.responseData.redirectUrl) {
                                window.location.href = data.responseData.redirectUrl;
                            }
                        } else {
                            shouldUnlockButton = true;
                            _this24.unblockPage();
                            window.brxTracking.sendAnalyticsEvent('book_online_book_tour_error');
                            if (_this24.bookingFromModal) {
                                _this24.closeOpenedModal();
                            }

                            if (data.errors) {
                                _this24.setErrors(data.errors);
                            } else if (data.responseData && data.responseData.redirectUrl) {
                                alert('Истекла авторизация. Страница будет перезагружена.');
                                window.location.href = data.responseData.redirectUrl;
                            }

                            if (!_this24.bookingFromModal) {
                                window.eventDispatcher.dispatchEvent('invalidPayer');
                            }
                        }

                        if (shouldUnlockButton) {
                            targetBtn.classList.remove('loader-btn');
                            window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                                target: targetBtn,
                                isShow: false
                            });
                        }
                    });
                }
            }, {
                key: "unblockPage",
                value: function unblockPage() {
                    window.eventDispatcher.dispatchEvent('_block-page', {
                        enable: false
                    });
                }
            }, {
                key: "closeOpenedModal",
                value: function closeOpenedModal() {
                    if (window.modal && typeof window.modal.close === 'function') {
                        window.modal.close('.modal2');
                    }
                }
            }, {
                key: "getFormData",
                value: function getFormData(formData) {
                    var data = {};

                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = formData.keys()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var key = _step4.value;

                            var keys = key.replace(/\]/g, '').split('[');
                            var obj = data;

                            for (var i = 0; i < keys.length; i++) {
                                var currentKey = keys[i];
                                if (i === keys.length - 1) {
                                    obj[currentKey] = formData.get(key);
                                } else {
                                    obj[currentKey] = obj[currentKey] || {};
                                    obj = obj[currentKey];
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    return data;
                }
            }, {
                key: "setErrors",
                value: function setErrors(errors) {
                    for (var type in errors) {
                        switch (type) {
                            case 'payer':
                                this.setPayerErrors(errors[type]);
                                break;
                            case 'TouristForm':
                                this.setTouristErrors(errors[type]);
                                break;
                            case 'bookingCreateError':
                                window.location.href = '/new/cabinet/my-tours';
                                break;
                            default:
                                this.setDefaultErrors(errors);
                                break;
                        }
                    }
                }
            }, {
                key: "setPayerErrors",
                value: function setPayerErrors(errors) {
                    var form = document.forms.payerForm;
                    var formFields = form.querySelectorAll('.form-group .form-control');

                    if (!this.bookingFromModal) {
                        document.querySelector('.tourists-info .payer').scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }

                    this.markErrorsField(formFields, errors, 'PayerForm');
                }
            }, {
                key: "setTouristErrors",
                value: function setTouristErrors(touristsErrors) {
                    var _this25 = this;

                    var forms = document.querySelectorAll('.tourist-form.collapse.open form');
                    var firstErrorForm = null;

                    var _loop2 = function _loop2(touristKey) {
                        var form = Array.from(forms).find(function (f) {
                            return f.dataset.index === touristKey;
                        });

                        if (!form) return "continue"; // Пропускаем, если подходящая форма не найдена

                        if (!firstErrorForm) {
                            firstErrorForm = form; // Запоминаем первую форму с ошибкой
                        }

                        var formFields = form.querySelectorAll('.form-group .form-control');
                        _this25.markErrorsField(formFields, touristsErrors[touristKey], "TouristForm[" + touristKey + "]");
                    };

                    for (var touristKey in touristsErrors) {
                        var _ret2 = _loop2(touristKey);

                        if (_ret2 === "continue") continue;
                    }

                    if (firstErrorForm) {
                        firstErrorForm.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }
            }, {
                key: "markErrorsField",
                value: function markErrorsField(formFields, errors, formName) {
                    for (var errorKey in errors) {
                        for (var i = 0; i < formFields.length; i++) {
                            if (formFields[i].name === formName + '[' + errorKey + ']') {
                                var formGroup = formFields[i].closest('.form-group');
                                var errorText = document.createElement('div');
                                errorText.className = 'error-text';
                                errorText.innerText = errors[errorKey];
                                formFields[i].after(errorText);
                                formGroup.classList.add('error');
                            }
                        }
                    }
                }
            }, {
                key: "beforeMarkErrorsField",
                value: function beforeMarkErrorsField() {
                    var formGroup = document.querySelectorAll('form .form-group');
                    var defaultErrors = document.querySelector('.default-errors');

                    defaultErrors.innerHTML = '';

                    formGroup.forEach(function (item) {
                        if (!item.classList.contains('error')) {
                            return;
                        }

                        item.classList.remove('error');
                        item.querySelector('.error-text').remove();
                    });
                }
            }, {
                key: "setDefaultErrors",
                value: function setDefaultErrors(errors) {
                    var defaultErrors = document.querySelector('.default-errors');

                    for (var k in errors) {
                        for (var j in errors[k]) {
                            var errorList = errors[k][j]['errors'];
                            for (var e in errorList) {
                                var errorText = document.createElement('div');
                                errorText.className = 'error-text';
                                errorText.innerText = errorList[e];

                                defaultErrors.append(errorText);
                            }
                        }
                    }
                }
            }, {
                key: "openPayerFormModal",
                value: function openPayerFormModal() {
                    var form = document.querySelector('.tourists-info .payer form[name="payerForm"]');
                    if (!form) return;

                    var modalContent = document.querySelector('.payer-form-modal');
                    if (!modalContent) {
                        return;
                    }

                    var originalParent = form.parentElement; // Запоминаем родителя
                    var originalNextSibling = form.nextSibling; // Запоминаем позицию

                    modalContent.innerHTML = ''; // Очищаем модалку
                    modalContent.appendChild(form); // Переносим форму в модалку

                    // Создаём кнопку "Оставить заявку"
                    var submitButton = document.createElement('button');
                    submitButton.type = 'button';
                    submitButton.className = 'btn btn-blue btn-next-step js-create-booking js-create-booking-ab';
                    submitButton.textContent = 'Оставить заявку';

                    // Вставляем кнопку в модалку после формы
                    modalContent.appendChild(submitButton);

                    // При закрытии модалки возвращаем форму обратно
                    window.modals['one-click-popup'].on('hidden', function (modal, event) {
                        form.name = 'payerForm';
                        if (originalNextSibling) {
                            originalParent.insertBefore(form, originalNextSibling);
                        } else {
                            originalParent.appendChild(form);
                        }
                    });

                    var eventProperties = {};
                    eventProperties['Type'] = 'payer-form';
                    window.brxTracking.sendAnalyticsEvent('open_one_click_modal', eventProperties);
                }
            }]);

            return Reservation;
        }();

        module.exports = Reservation;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var RoomSelection = function () {
            function RoomSelection(params) {
                var _this26 = this;

                _classCallCheck(this, RoomSelection);

                this.params = params;
                this.labels = params.labels;
                this.rooms = null;
                this.loading = false;
                this.panel = document.getElementById('bookingRoomsPanel');
                this.content = this.panel.querySelector('[data-booking-room-content]');
                this.navigation = this.panel.querySelector('[data-booking-room-nav]');
                this.button = document.querySelector('.js-change-room');
                this.selectedButton = document.querySelector('.btn-selected-room');
                this.button.addEventListener('click', function () {
                    if (_this26.loading) {
                        return;
                    }
                    if (_this26.rooms === null) {
                        _this26.load();
                    } else if (_this26.rooms.length) {
                        _this26.open();
                    }
                });
                this.load();
            }

            _createClass(RoomSelection, [{
                key: "open",
                value: function open() {
                    var _this27 = this;

                    window.modal.open({
                        header: null,
                        content: { htmlDetachSelectorId: 'bookingRoomsPanel' },
                        parentCssClass: 'hotel-reviews-panel-modal booking-room-selection-modal',
                        footer: null,
                        type: 'full',
                        onAfterShow: function onAfterShow() {
                            return _this27.initGalleries();
                        }
                    });
                    window.brxTracking.sendAnalyticsEvent('click_on_hotel_room', { Place: this.params.eventPlace });
                    if (this.rooms === null && !this.loading) {
                        this.load();
                    }
                }
            }, {
                key: "load",
                value: function load() {
                    var _this28 = this;

                    this.loading = true;
                    this.button.disabled = true;
                    this.button.title = '';
                    this.button.textContent = this.labels.loading;
                    this.button.classList.add('is-loading');
                    this.button.classList.remove('hide');
                    this.selectedButton.classList.add('hide');
                    this.content.replaceChildren();
                    this.content.textContent = this.labels.loading;
                    ajax.get(this.params.loadRoomsUrl, {}, function (data) {
                        _this28.loading = false;
                        _this28.rooms = data.success ? data.responseData.rooms : [];
                        _this28.button.disabled = false;
                        _this28.button.classList.remove('is-loading');
                        _this28.button.textContent = _this28.params.isSplitRooms ? _this28.labels.view : _this28.labels.change;
                        _this28.button.classList.toggle('hide', _this28.rooms.length === 0);
                        _this28.selectedButton.classList.toggle('hide', _this28.rooms.length !== 0);
                        _this28.render();
                    }, function () {
                        _this28.loading = false;
                        _this28.button.disabled = false;
                        _this28.button.classList.remove('is-loading');
                        _this28.button.textContent = _this28.labels.retry;
                        _this28.button.title = _this28.labels.error;
                    });
                }
            }, {
                key: "render",
                value: function render() {
                    var _this29 = this;

                    this.content.textContent = '';
                    this.content.replaceChildren();
                    this.navigation.replaceChildren();
                    var variants = this.params.isSplitRooms ? this.rooms : [this.params.baseRoom].concat(_toConsumableArray(this.rooms));
                    var activeIndex = 0;
                    variants.forEach(function (room, index) {
                        var selected = !_this29.params.isSplitRooms && index === 0;
                        var button = _this29.element('button', 'hotel-rooms-panel__tab');
                        button.type = 'button';
                        var photo = _this29.element('img', '');
                        photo.src = room.detail && room.detail.photos.length ? room.detail.photos[0] : '/x-assets/img/no-image.svg';
                        photo.alt = '';
                        photo.loading = 'lazy';
                        button.appendChild(photo);
                        var label = _this29.element('span', '', room.name);
                        if (selected || room.diff) label.appendChild(_this29.element('div', 'booking-rooms-panel__price', selected ? _this29.labels.selected : room.diff));
                        button.appendChild(label);
                        var show = function show() {
                            _this29.content.querySelectorAll('.room-selection__gallery').forEach(function (gallery) {
                                if (gallery.swiper) gallery.swiper.destroy(true, true);
                            });
                            _this29.content.replaceChildren(_this29.renderRoom(room, selected));
                            Array.from(_this29.navigation.children).forEach(function (tab) {
                                return tab.setAttribute('aria-current', String(tab === button));
                            });
                            _this29.initGalleries();
                            var scroller = _this29.panel.closest('.modal2-content');
                            if (scroller) scroller.scrollTop = 0;
                        };
                        button.addEventListener('click', function () {
                            if (activeIndex === index) return;
                            activeIndex = index;
                            if (window.brxTracking) window.brxTracking.sendAnalyticsEvent('hotel_room_change', Object.assign({}, window.app && window.app.pageParams, { context: 'booking',
                                Place: _this29.params.eventPlace, room_id: room.detail && room.detail.id, tour_id: room.tourId, room_index: index }));
                            show();
                        });
                        _this29.navigation.appendChild(button);
                        if (index === 0) show();
                    });
                    if (this.rooms.length === 0) {
                        this.content.appendChild(this.element('p', 'room-selection__message', this.labels.empty));
                    }
                }
            }, {
                key: "renderRoom",
                value: function renderRoom(room, selected) {
                    var _this30 = this;

                    var detail = room.detail;
                    var card = this.element('div', 'online-booking-rooms room-selection__room' + (!detail ? ' short-room' : ''));
                    var body = this.element('div', 'rooms content-block');
                    if (detail) {
                        body.appendChild(this.renderGallery(detail.photos, room.name));
                    }
                    var info = this.element('div', 'room-info');
                    info.appendChild(this.element('div', 'room-name', selected && detail ? detail.name : room.name));
                    info.appendChild(this.element('div', 'room-description', detail ? detail.description : ''));
                    if (detail && detail.services && detail.services.length) {
                        var _services2 = this.element('div', 'room-params');
                        detail.services.forEach(function (service) {
                            var item = _this30.element('div', 'room-param');
                            item.appendChild(_this30.element('span', '', service.name));
                            item.appendChild(document.createTextNode(': ' + service.value));
                            _services2.appendChild(item);
                        });
                        info.appendChild(_services2);
                    }
                    if (this.params.isSplitRooms && detail && detail.accommodation) {
                        var accommodation = detail.accommodation;
                        info.appendChild(this.element('p', 'room-selection__accommodation', this.labels.adults + ': ' + accommodation.adults + ', ' + this.labels.children + ': ' + accommodation.child));
                    }
                    body.appendChild(info);
                    card.appendChild(body);
                    var services = info.querySelector('.room-params');
                    if (services) card.appendChild(services);
                    var action = this.element('div', 'rooms-action content-block');
                    if (selected) {
                        action.appendChild(this.element('div', 'btn btn-selected btn-selected-room', this.labels.selected));
                    } else if (!this.params.isSplitRooms) {
                        if (room.diff) {
                            action.appendChild(this.element('div', 'room-selection__diff', room.diff));
                        }
                        var link = this.element('a', 'btn btn-blue', this.labels.select);
                        link.href = this.params.newTourUrl + '/' + encodeURIComponent(room.tourId) + window.location.search;
                        link.addEventListener('click', function () {
                            window.brxTracking.sendAnalyticsEvent('click_to_select_hotel_room', { Place: _this30.params.eventPlace });
                        });
                        action.appendChild(link);
                    }
                    var header = this.element('div', 'booking-rooms-panel__room-header');
                    header.appendChild(info.querySelector('.room-name'));
                    header.appendChild(action);
                    card.prepend(header);
                    if (!detail && !this.params.isSplitRooms) body.remove();
                    return card;
                }
            }, {
                key: "renderGallery",
                value: function renderGallery(photos, name) {
                    var _this31 = this;

                    var gallery = this.element('div', 'rooms-gallery');
                    if (!photos.length) {
                        var wrapper = this.element('div', 'room-image-wrapper');
                        var image = this.element('img', 'room-image');
                        image.src = '/x-assets/img/no-image.svg';
                        image.alt = name;
                        wrapper.appendChild(image);
                        gallery.appendChild(wrapper);
                        return gallery;
                    }
                    var slider = this.element('div', 'swiper room-selection__gallery');
                    var slides = this.element('div', 'swiper-wrapper');
                    photos.forEach(function (src) {
                        var slide = _this31.element('div', 'swiper-slide');
                        var image = _this31.element('img', '');
                        image.src = src;
                        image.alt = name;
                        image.loading = 'lazy';
                        slide.appendChild(image);
                        slides.appendChild(slide);
                    });
                    slider.appendChild(slides);
                    slider.appendChild(this.element('div', 'swiper-pagination'));
                    slider.appendChild(this.element('div', 'swiper-button-prev'));
                    slider.appendChild(this.element('div', 'swiper-button-next'));
                    gallery.appendChild(slider);
                    return gallery;
                }
            }, {
                key: "initGalleries",
                value: function initGalleries() {
                    this.content.querySelectorAll('.room-selection__gallery').forEach(function (element) {
                        if (element.swiper) {
                            element.swiper.update();
                            return;
                        }
                        new Swiper(element, {
                            slidesPerView: 1,
                            loop: false,
                            pagination: { el: element.querySelector('.swiper-pagination'), clickable: true },
                            navigation: {
                                prevEl: element.querySelector('.swiper-button-prev'),
                                nextEl: element.querySelector('.swiper-button-next')
                            }
                        });
                    });
                }
            }, {
                key: "element",
                value: function element(tag, className) {
                    var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

                    var element = document.createElement(tag);
                    element.className = className;
                    element.textContent = text;
                    return element;
                }
            }]);

            return RoomSelection;
        }();

        module.exports = RoomSelection;
    }, {}] }, {}, [1]);